/**
 * Google Maps Distance Calculation Utility
 * Simple function to calculate distance in kilometers using Google Maps
 */

/**
 * Calculate driving distance between two points using Google Maps Directions API
 * @param lat1 - Latitude of first point
 * @param lng1 - Longitude of first point
 * @param lat2 - Latitude of second point
 * @param lng2 - Longitude of second point
 * @returns Promise<number> - Driving distance in kilometers
 */
export const calculateDistance = async (
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): Promise<number> => {
  return new Promise((resolve, reject) => {
    // Check if Google Maps is loaded
    if (!window.google || !window.google.maps) {
      reject(new Error('Google Maps API not loaded'));
      return;
    }

    try {
      const directionsService = new window.google.maps.DirectionsService();
      const origin = new window.google.maps.LatLng(lat1, lng1);
      const destination = new window.google.maps.LatLng(lat2, lng2);

      directionsService.route(
        {
          origin: origin,
          destination: destination,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === 'OK' && result && result.routes?.[0]?.legs?.[0]?.distance?.value) {
            // Get the total distance from the first route
            const distanceInMeters = result.routes[0].legs[0].distance.value;
            const distanceInKm = parseFloat((distanceInMeters / 1000).toFixed(1));
            // console.log('Driving distance in km:', distanceInKm);
            resolve(distanceInKm);
          } else {
            console.error('Directions request failed:', status);
            reject(new Error(`Directions request failed: ${status}`));
          }
        }
      );
    } catch (error) {
      reject(new Error(`Error calculating driving distance: ${error}`));
    }
  });
};

